// extracted by mini-css-extract-plugin
export default {"container":"EmailInfo_container__hJASM","grid":"EmailInfo_grid__jRraV","fieldTitle":"EmailInfo_fieldTitle__K3ot9","fieldValue":"EmailInfo_fieldValue__P+f+T"};